import {
  aMap,
  location,
  SearchCity,
  getCityconvertFrom,
  LocalCity
} from '@/utils/aMap'

const setDeafultLocal = ({ commit, state }) => {
  state.locationInfo.lat = 23.12463
  state.locationInfo.lng = 113.36199
  state.locationInfo.city = '广州市'
  state.locationInfo.province = '广东省'
}

// 获取定位信息
const getLocation = ({ commit, state }) => {
  return new Promise(async (resolve, reject) => {
    try {
      const AMapLocation = await location().catch(err => {
        console.error(err, '初始化定位失败')
        // 初始化失败时直接使用默认位置
        setDeafultLocal({ commit, state })
        resolve({
          status: true,
          data: {},
          message: '使用默认位置'
        })
        return null
      })

      // 如果初始化失败，直接返回
      if (!AMapLocation) return

      // 设置更合理的超时处理
      const timeoutPromise = new Promise((_, reject) => {
        setTimeout(() => {
          console.warn('定位超时，使用默认位置')
          setDeafultLocal({ commit, state })
          resolve({
            status: true,
            data: {},
            message: '定位超时，使用默认位置'
          })
        }, 4000)
      })

      // 尝试获取位置
      const locationPromise = new Promise(
        (resolve, reject) => {
          AMapLocation.getCurrentPosition(
            async (status, result) => {
              if (status === 'complete') {
                state.locationInfo.lng = result.position.lng
                state.locationInfo.lat = result.position.lat

                try {
                  const AMapSearchCity = await SearchCity().catch(
                    err => {
                      console.error(
                        err,
                        '初始化获取城市失败'
                      )
                      // 即使城市获取失败，也使用定位的经纬度
                      resolve({
                        status: true,
                        data: result,
                        message:
                          '获取定位成功，城市信息获取失败'
                      })
                      return null
                    }
                  )

                  if (!AMapSearchCity) return

                  const lnglat = [
                    result.position.lng,
                    result.position.lat
                  ]

                  AMapSearchCity.getAddress(
                    lnglat,
                    (addressStatus, addressResult) => {
                      if (
                        addressStatus === 'complete' &&
                        addressResult.info === 'OK'
                      ) {
                        state.locationInfo.city =
                          addressResult.regeocode
                            .addressComponent.city ||
                          '未知城市'
                        state.locationInfo.province =
                          addressResult.regeocode
                            .addressComponent.province ||
                          '未知省份'
                        resolve({
                          status: true,
                          data: {
                            ...addressResult
                          },
                          message: '获取定位成功'
                        })
                      } else {
                        // 地址解析失败时仍然使用经纬度
                        resolve({
                          status: true,
                          data: result,
                          message:
                            '获取定位成功，地址解析失败'
                        })
                      }
                    }
                  )
                } catch (err) {
                  console.error('获取城市信息失败:', err)
                  // 出现异常时仍然返回定位结果
                  resolve({
                    status: true,
                    data: result,
                    message:
                      '获取定位成功，处理过程中出现异常'
                  })
                }
              } else {
                // 定位失败时尝试通过IP获取城市信息
                AMapLocation.getCityInfo(
                  (status, result) => {
                    if (status === 'complete') {
                      state.locationInfo.lat =
                        result.position[1] || ''
                      state.locationInfo.lng =
                        result.position[0] || ''
                      state.locationInfo.city =
                        result.city || '广州市'
                      state.locationInfo.province =
                        result.province || '广东省'
                      resolve({
                        status: true,
                        data: {
                          ...result
                        },
                        message: '通过IP获取位置信息成功'
                      })
                    } else {
                      console.error(
                        `状态: ${status} \n 结果:${result}`,
                        '定位失败'
                      )

                      // 设置默认地址
                      setDeafultLocal({ commit, state })
                      resolve({
                        status: true,
                        data: {},
                        message: '定位失败，使用默认位置'
                      })
                    }
                  }
                )
              }
            }
          )
        }
      )

      // 等待定位完成或超时
      Promise.race([locationPromise, timeoutPromise]).catch(
        err => {
          console.error('定位过程异常:', err)
          setDeafultLocal({ commit, state })
          resolve({
            status: true,
            data: {},
            message: '定位过程异常，使用默认位置'
          })
        }
      )
    } catch (err) {
      console.error('定位服务异常:', err)
      setDeafultLocal({ commit, state })
      resolve({
        status: true,
        data: {},
        message: '定位服务异常，使用默认位置'
      })
    }
  })
}

const setCity = ({ commit, state }, cityName) => {
  return new Promise(async (resolve, reject) => {
    const AMapSearchCity = await SearchCity(cityName)

    AMapSearchCity.getLocation(cityName, function(
      status,
      result
    ) {
      if (status === 'complete' && result.info === 'OK') {
        // result中对应详细地理坐标信息
        const res = result.geocodes[0]
        state.locationInfo.lng = res.location.lng
        state.locationInfo.lat = res.location.lat
        state.locationInfo.city = res.addressComponent.city
        state.locationInfo.province =
          res.addressComponent.province
        resolve({
          status: true
        })
      } else {
        console.error(
          `状态: ${status} \n 结果:${result}`,
          '定位失败'
        )

        resolve({
          status: false
        })
      }
    })
  })
  // AMapSearchCity.CitySearchCallback(
  //   ({ ip: '北京' }, result) => {
  //   }
  // )
}

const state = {
  locationInfo: {
    accuracy: '',
    adcode: '',
    addr: '',
    city: '',
    district: '',
    lat: '',
    lng: '',
    module: '',
    nation: '',
    province: '',
    type: '',
    id: ''
  }
}

const mutations = {}

const actions = {
  getLocation,
  setCity
  // async getLocation({ commit, state }) {

  // }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
